import type { QaItem } from '../../types/qa';

export const qaItems: QaItem[] = [
  // qaLogin
  // ----------------------------------------
  {
    category: 'qaLogin',
    icon: 'help_center',
    question: {
      ja: 'ユーザIDがわからない',
      en: 'User ID',
    },
    answer: {
      ja: '基本的にはご利用申請時のメールアドレスとなります。\n\
      【注意】一度発行したユーザーIDを変更することはできませんので、ご注意ください。',
      en: 'Your email address when applying for use.',
    },
  },
  {
    category: 'qaLogin',
    icon: 'help_center',
    question: {
      ja: 'パスワードを忘れてしまった・確認したい',
      en: 'How to reset your password',
    },
    answer: {
      ja: 'ログイン画面の「パスワードをリセットする場合はこちらから」より、パスワードリセットをしてください。',
      en: 'Please reset your password from "Click here to reset your password" on the login screen.',
    },
  },
  {
    category: 'qaLogin',
    icon: 'help_center',
    question: {
      ja: 'パスワードを５回以上間違えてしまい、ロックされてしまった',
      en: '',
    },
    answer: {
      ja: 'ログインする際、パスワードなどを規定回数（5回）以上、続けて間違われますと、アカウントがロック（ロックアウト）されます。\n\
      　ロックアウトの解除はパスワードリセットで対応しております。\n\
      　ログイン画面の「パスワードをリセットする場合はこちらから」より、パスワードリセットをしてください。',
      en: '',
    },
  },
  {
    category: 'qaLogin',
    icon: 'help_center',
    question: {
      ja: 'Timssにアクセスするとログイン画面がおかしい or 表示されない',
      en: '',
    },
    answer: {
      ja: 'PC環境によって、様々な事象が出る可能性があります。\n\
      ① ログインできない、ページが正しく表示されない。 ⇒ ブラウザの設定に起因した問題\n\
      　ブラウザのcookie・キャッシュクリアを実施することで改善する場合があります。\n\
      　キャッシュクリア（※）を実施の上、再度ログイン情報を入力してください。\n\
      ② 何らかのエラーメッセージが表示される。 ⇒ URLが間違っている or システム側の障害の可能性あり\n\
      ③ 画面が応答待ちのままかえってこない ⇒ ネットワークの問題 or システム側の障害の可能性あり',
      en: '',
    },
    additional: [
      {
        type: 'link',
        description: {
          ja: '（※）具体的なクリアの手順は下記のChromeサポートページをご参照ください。',
          en: '',
        },
        link: 'https://support.google.com/accounts/answer/32050',
        linkText: 'https://support.google.com/accounts/answer/32050',
      },
      {
        type: 'img',
        description: {
          ja: '（※）WindowsでChromeをご利用の場合、下図のように［Shift］＋［Ctrl］＋［R］キーを同時に押すとキャッシュクリアできます',
          en: '',
        },
        // 元画像 http://www.sharots.com/sozai/keyboard.html
        imgPath: '/images/qa/qa-shortcut.jpg',
        imgAlt: '［Shift］＋［Ctrl］＋［R］キー',
      },
    ],
  },
  // qaId
  // ----------------------------------------
  {
    category: 'qaId',
    icon: 'help_center',
    question: {
      ja: 'パスワードの変更方法やルールは？',
      en: '',
    },
    answer: {
      ja: 'パスワードを変更したい場合は、ログイン画面の「パスワードをリセットする場合はこちらから」より、パスワードリセットをしてください。',
      en: '',
    },
  },
  {
    category: 'qaId',
    icon: 'help_center',
    question: {
      ja: 'パスワードを再発行してほしい',
      en: '',
    },
    answer: {
      ja: 'ログイン画面の「パスワードをリセットする場合はこちら」よりパスワードリセットをしてください。',
      en: '',
    },
  },
  {
    category: 'qaId',
    icon: 'help_center',
    question: {
      ja: 'パスワードリセットしたが、認証コードのメールが届かない',
      en: '',
    },
    answer: {
      ja: '迷惑メールフォルダへ転送されてないか確認をお願いします。\n\
      \n\
      迷惑メールフォルダにも届いていない場合、会社やプロバイダのファイアウォールによってドメインブロックされている可能性がございます。\n\
      「認証メールが送信された後」〜「取引先様のメールサーバにそれが届く前」の経路で問題が起きている可能性があるため、\n\
      迷惑メールフォルダへ移される前に、ドメインブロックされるような設定がされていないか等ご確認をお願いします。\n\
      ※認証コード通知メールの送信元ドメインは「 verificationmail.com 」です。\n\
      \n\
      ドメインブロック解除してもメール通知されない場合は、Timss管理者までご連絡ください。',
      en: '',
    },
  },
  {
    category: 'qaId',
    icon: 'help_center',
    question: {
      ja: 'ユーザIDを変更したい',
      en: '',
    },
    answer: {
      ja: '一度登録されたTimssのユーザIDは、原則変更することができません。\n\
      変更する必要がある場合は、利用申込書に必要事項を記入いただき、営業担当までご連絡ください。',
      en: '',
    },
  },
  {
    category: 'qaId',
    icon: 'help_center',
    question: {
      ja: 'メールアドレスが変わった時のユーザIDは？',
      en: '',
    },
    answer: {
      ja: 'メールアドレスが変更になっても、ユーザIDはTimss登録時のメールアドレスからの変更はありません。\n\
      【注意】　一度発行したユーザIDは、原則変更することはできませんのでご注意ください。',
      en: '',
    },
  },
  // qaAccount
  // ----------------------------------------
  {
    category: 'qaAccount',
    icon: 'help_center',
    question: {
      ja: '自分のアカウント状況を知りたい',
      en: 'Account status',
    },
    answer: {
      ja: 'ユーザ様のご利用状況は、メニューバーに表示されている「プロフィール・ユーザー情報」よりご確認いただけます。',
      en: 'Check the user\'s usage status from "User Info" displayed on the menu bar.',
    },
  },
  {
    category: 'qaAccount',
    icon: 'help_center',
    question: {
      ja: '異動、退職等の理由でTimssを利用しなくなる',
      en: 'Stop using due to transfer or retirement',
    },
    answer: {
      ja: '異動や退職でTimssを利用されなくなる場合は、利用申請書に削除するID情報をご記入いただき、営業担当までご連絡ください。',
      en: 'Please fill in the ID information to be deleted on the application form and contact the Timss administration office.',
    },
  },
  // qaApplication
  // ----------------------------------------
  {
    category: 'qaApplication',
    icon: 'help_center',
    question: {
      ja: '利用申請をどこに出せばいいのかわからない',
      en: '',
    },
    answer: {
      ja: '利用申請書につきましては、お取引のある営業担当までご連絡ください。',
      en: '',
    },
  },
  {
    category: 'qaApplication',
    icon: 'help_center',
    question: {
      ja: '利用申請方法を教えてほしい',
      en: 'Application for use',
    },
    answer: {
      ja: 'メニューバーに表示されている「利用申請書」に必要事項を記入いただき、営業担当までご連絡ください。',
      en: 'Please fill in the necessary information on the "Application for Use" displayed on the menu bar and contact the Timss administration office.',
    },
  },
  {
    category: 'qaApplication',
    icon: 'help_center',
    question: {
      ja: '利用申請後のスケジュールは？',
      en: '',
    },
    answer: {
      ja: '利用可能となるまでの期間を詳しく知りたい方は、営業担当までご連絡ください。',
      en: '',
    },
  },
  {
    category: 'qaApplication',
    icon: 'help_center',
    question: {
      ja: '利用申請したのに承認されない',
      en: '',
    },
    answer: {
      ja: 'Timss管理者から営業担当に確認いたします。\n\
      お手数をお掛けいたしますが、下記必要事項をTimss管理者までご連絡ください。\n\
      \n\
      【記載事項】\n\
      　・利用申請書を送付した営業担当の氏名・連絡先\n\
      　・利用申請対象の会社名、氏名、メールアドレス\n\
      　・利用申請実施日時',
      en: '',
    },
  },
  // qaInfo
  // ----------------------------------------
  {
    category: 'qaInfo',
    icon: 'help_center',
    question: {
      ja: 'インフォメーションについて',
      en: '',
    },
    answer: {
      ja: 'システムに関するお知らせ事項を表示します。\n\
      ・システムメンテナンスによる停止\n\
      ・システム改修のお知らせ\n\
      ・アカウント利用継続のお知らせ',
      en: '',
    },
  },
  {
    category: 'qaInfo',
    icon: 'help_center',
    question: {
      ja: '緊急通知について',
      en: '',
    },
    answer: {
      ja: 'システム障害など、利用困難な場合にお知らせします。',
      en: '',
    },
  },
  {
    category: 'qaInfo',
    icon: 'help_center',
    question: {
      ja: '通知メールのメールアドレス・ドメインについて',
      en: 'Notification email domain',
    },
    answer: {
      ja: 'Timssから配信されるメールの送信元メールアドレスは下記の通りです。\n\
      \n\
      ・ユーザID登録完了メール: no-reply@timss.toyota-tsusho.com\n\
      ・パスワードリセット時の認証コードメール: no-reply@timss.toyota-tsusho.com\n\
      ・新着通知メール: 1159-timss@dist.toyota-tsusho.com\n\
      ・アカウント継続利用確認メール: 1159-timss@dist.toyota-tsusho.com\n\
      \n\
      【注意】上記ドメインからメール通知されますので、メールをブロックしないよう設定のご確認をお願いします。',
      en: "The sender's e-mail address delivered from Timss is as follows.\n\
      \n\
      ・Notification of User registration completed: no-reply@timss.toyota-tsusho.com\n\
      ・Notice of Verification code: no-reply@timss.toyota-tsusho.com\n\
      ・Question about your intention to continue your account. : 1159-timss@dist.toyota-tsusho.com\n\
      ・Receipt notification of new mill sheet: 1159-timss@dist.toyota-tsusho.com\n\
      \n\
      [Caution] You will be notified by e-mail from the above domain, so please check your settings so that the e-mail is not blocked.\n\
      \n\
      If you do not receive an email notification, please check whether it has been forwarded to your spam folder.\n\
      \n\
      If you do not receive an email notification even after unblocking the domain, please contact the Timss administration office.",
    },
  },
  {
    category: 'qaInfo',
    icon: 'help_center',
    question: {
      ja: '「ユーザID登録完了のお知らせ」が届いた',
      en: '',
    },
    answer: {
      ja: 'ユーザID登録完了後、Timssを利用開始していただけます。\n\
      メール本文に記載ある初回パスワードでログイン後、任意のパスワードに変更してください。',
      en: '',
    },
  },
  {
    category: 'qaInfo',
    icon: 'help_center',
    question: {
      ja: '「認証コードのお知らせ」が届いた',
      en: '',
    },
    answer: {
      ja: 'パスワードリセットをすると、認証コードが通知されます。\n\
      認証コードを入力し、パスワードを変更してください。',
      en: '',
    },
  },
  {
    category: 'qaInfo',
    icon: 'help_center',
    question: {
      ja: '「新着ミルシート受信」が届いた',
      en: '',
    },
    answer: {
      ja: '新たにミルシートデータ取得した際、メールで通知されます。\n\
      メール本文の記載内容・項目は以下の通りです。\n\
      ・取得件数、取得日時\n\
      ・ミルシート取得情報\n\
      　国内向け：鉄鋼メーカー、工場、契約番号、規格、寸法、溶解番号、需要家名、証明書年月日、証明書番号\n\
      　輸出向け：上記項目、SC No.(商社契約番号)',
      en: '',
    },
  },
  {
    category: 'qaInfo',
    icon: 'help_center',
    question: {
      ja: '「アカウント継続利用の確認」が届いた',
      en: 'Confirmation of renewing Timss account',
    },
    answer: {
      ja: 'アカウント情報棚卸のため、Timssの継続利用要否のご案内です。\n\
      継続利用する/利用しないの回答をしてください。\n\
      継続利用しない場合は、回答期限後にユーザID失効します。\n\
      \n\
      【注意】ID失効の際は、通知はありませんのでご了承ください。',
      en: "We are currently checking if you would like to extend your Timss account for users' accounts management purpose. Please confirm if you would like to extend account and click accordingly.\n\
      Even if you choose to delete your account, the account will not be deleted immediately. You can use it until the date described in the email.\n\
      \n\
      [Note] Please note that there is no notification when the ID expires.",
    },
  },
  {
    category: 'qaInfo',
    icon: 'help_center',
    question: {
      ja: '通知メールが届かない',
      en: '',
    },
    answer: {
      ja: '迷惑メールフォルダへ転送されてないか確認をお願いします。\n\
      \n\
      迷惑メールフォルダにも届いていない場合、会社やプロバイダのファイアウォールによってドメインブロックされている可能性がございます。\n\
      「認証メールが送信された後」〜「取引先様のメールサーバにそれが届く前」の経路で問題が起きている可能性があるため、\n\
      迷惑メールフォルダへ移される前に、ドメインブロックされるような設定がされていないか等ご確認をお願いします。\n\
      ※認証コード通知メールの送信元ドメインは「 verificationmail.com 」です。\n\
      \n\
      ドメインブロック解除してもメール通知されない場合は、Timss管理者までご連絡ください。',
      en: '',
    },
  },
  {
    category: 'qaInfo',
    icon: 'help_center',
    question: {
      ja: '「ユーザID登録完了」の通知メールを紛失し初回パスワードがわからない',
      en: '',
    },
    answer: {
      ja: '再度新規ユーザ登録が必要になりますので、Timss管理者までご連絡ください。',
      en: '',
    },
  },
  {
    category: 'qaInfo',
    icon: 'help_center',
    question: {
      ja: '新着メールを受信したい/停止したい',
      en: '',
    },
    answer: {
      ja: 'メニューバーに表示されている「プロフィール・ユーザー情報」より、ミルシート受領メール通知の有効/無効が設定できます。\n\
      \n\
      初期設定は、ユーザID新規登録利用申請書の新着メール欄のチェック有無で登録されています。',
      en: '',
    },
  },
  {
    category: 'qaInfo',
    icon: 'help_center',
    question: {
      ja: '新着メールで受け取る明細の条件設定はできるか',
      en: '',
    },
    answer: {
      ja: '新着メールを有効にした場合、可視制御されている全明細が通知されるようになっています。\n\
      \n\
      メニューにあるユーザ情報の「ミルシート受領メール通知」より「通知絞り込み設定」が可能です。\n\
      通知を受信したい需要家名を選択することで、受け取りたい条件を設定できます。\n\
      例：一部の工場分だけ通知してほしい　→　需要家名が工場別に分かれている場合は設定可能',
      en: '',
    },
  },
  // qaTimss
  // ----------------------------------------
  {
    category: 'qaTimss',
    icon: 'help_center',
    question: {
      ja: 'Timssとは何ですか',
      en: '',
    },
    answer: {
      ja: '鉄鋼メーカーが発行するミルシートの検索、ダウンロードができるシステムです。',
      en: '',
    },
  },
  {
    category: 'qaTimss',
    icon: 'help_center',
    question: {
      ja: 'TimssのユーザIDとは何ですか？',
      en: '',
    },
    answer: {
      ja: 'TimssのユーザIDとは、Timssのログインに必要なユーザ様ごとの「名前」です。\n\
      \n\
      ログイン画面の「ユーザID」の欄に入力して頂き、ご自身のパスワードを入力することによりTimssにログインが可能となります。',
      en: '',
    },
  },
  {
    category: 'qaTimss',
    icon: 'help_center',
    question: {
      ja: '初期パスワードについて',
      en: '',
    },
    answer: {
      ja: '初期パスワードは新規利用申請で承認時にシステムから自動的に発行される仮パスワードです。\n\
      \n\
      初期パスワードの体系について以下の通りです。\n\
      　・8文字（1文字以上の半角小文字）\n\
      　・有効期限7日\n\
      　・通知メールからコピー＆貼り付けで入力される場合は、前後に半角スペースが混入する可能性がございますので、ご注意ください',
      en: '',
    },
  },
  {
    category: 'qaTimss',
    icon: 'help_center',
    question: {
      ja: 'システム利用できる時間帯は？',
      en: '',
    },
    answer: {
      ja: '本システムは24時間ご利用可能ですが、メンテナンス等で一時的にご利用いただけない場合があります。\n\
      その場合は、ログイン画面インフォメーションでお知らせします。',
      en: '',
    },
  },
  {
    category: 'qaTimss',
    icon: 'help_center',
    question: {
      ja: 'ミルシートデータはいつ反映されますか？',
      en: '',
    },
    answer: {
      ja: '鉄鋼メーカーより鋼材出荷した翌日以降にミルシート電子データ取得、Timssにデータ反映されます。\n\
      \n\
      Timssにミルシート電子データが反映されると、新着メールにてお知らせする機能があります。\n\
      新着メール機能の詳細は、「Timssについて」のタブにある「新着メールを受信したい/停止したい」をご参照ください。\n\
      \n\
      【注意】豊田通商の非稼働日、非稼働時間帯はデータの更新はされません。また問い合わせも対応いたしかねますのでご了承ください。',
      en: '',
    },
  },
  {
    category: 'qaTimss',
    icon: 'help_center',
    question: {
      ja: 'データの保管期間は何年ですか？ ',
      en: '',
    },
    answer: {
      ja: '現時点にて保管期間に制限を設けていません。',
      en: '',
    },
  },
  {
    category: 'qaTimss',
    icon: 'help_center',
    question: {
      ja: '検索・ダウンロード件数の上限はありますか？',
      en: '',
    },
    answer: {
      ja: '検索表示できる上限件数は、2000件です。\n\
      ダウンロードの上限件数は、200件です。',
      en: '',
    },
  },
  {
    category: 'qaTimss',
    icon: 'help_center',
    question: {
      ja: '寸法の複数検索はできますか？',
      en: '',
    },
    answer: {
      ja: '検索オプション画面の寸法のFrom枠に、半角カッコ内にOR条件で検索したい寸法と半角スペースを入力することで検索可能です（ORは大文字）。\n\
      \n\
      入力例：(24 OR 36 OR 48)',
      en: '',
    },
  },
  {
    category: 'qaTimss',
    icon: 'help_center',
    question: {
      ja: '溶解番号の複数検索はできますか？',
      en: '',
    },
    answer: {
      ja: '検索オプション画面の溶解番号に、「バーティカルバー（｜ / 縦線）」区切りで検索可能です。\n\
      Shiftキーを押しながら「￥」が書いてある右上の方にあるキーを押すと「|」が入力されます。\n\
      \n\
      入力例：1A2345|9B8765|5C6789',
      en: '',
    },
  },
  {
    category: 'qaTimss',
    icon: 'help_center',
    question: {
      ja: 'ミルシートが検索結果に表示されない',
      en: 'Mill sheet data not displayed',
    },
    answer: {
      ja: '検索結果に表示されないミルシート情報を、営業担当までご連絡ください（規格・寸法・溶解番号など）\n\
      想定される要因は以下の可能性がございます。\n\
      ①可視制御が設定されていない\n\
      ②システム側のデータ取り込みエラー\n\
      ③鉄鋼メーカーによる電子発行対象になっていない',
      en: 'Please contact our sales representative for mill sheet information that is not displayed in the search results.',
    },
  },
  {
    category: 'qaTimss',
    icon: 'help_center',
    question: {
      ja: 'このヘルプページについて',
      en: '',
    },
    answer: {
      ja: 'Timssに関するお問合せの多かったものを元に掲載されております。\n\
      各項目の内容は下記の通りです。\n\
      \n\
      ログインで困ったら\n\
      　主にログインで陥りやすい問題などに対応した項目を掲載しております。\n\
      \n\
      ユーザID/パスワードについて\n\
      　ユーザIDやパスワードなど、体系などについて対応した項目を掲載しております。\n\
      \n\
      アカウントについて\n\
      　アカウント情報について対応した項目を掲載しております。\n\
      \n\
      お知らせ・確認メールについて\n\
      　Timssから自動で送付されるメールについて対応した項目を掲載しております。\n\
      \n\
      利用申請で困ったら\n\
      　利用申請や取消申請などに対応した項目を掲載しております。\n\
      \n\
      Timssについて\n\
      　Timssのメニュー及び機能ついて説明を掲載しております。',
      en: '',
    },
  },
  // qaRegistration
  // ----------------------------------------
  {
    category: 'qaRegistration',
    icon: 'help_center',
    question: {
      ja: '組織を新規登録したい',
      en: '',
    },
    answer: {
      ja: '登録したい組織(会社名)をTimss管理者までご連絡ください。',
      en: '',
    },
  },
  {
    category: 'qaRegistration',
    icon: 'help_center',
    question: {
      ja: '組織を編集したい（名称変更・削除）',
      en: '',
    },
    answer: {
      ja: '編集したい組織(会社名)、名称変更する理由、削除する理由とともに、Timss管理者までご連絡ください。',
      en: '',
    },
  },
  {
    category: 'qaRegistration',
    icon: 'help_center',
    question: {
      ja: 'ユーザID登録・削除をしたい',
      en: '',
    },
    answer: {
      ja: '必要事項が記入済の利用申請書をTimss管理者までご連絡ください。',
      en: '',
    },
  },
  {
    category: 'qaRegistration',
    icon: 'help_center',
    question: {
      ja: '可視制御を登録・編集したい',
      en: '',
    },
    answer: {
      ja: 'メニューバーに表示ある「可視制御」より、可視制御情報を登録していただき、承認依頼をしてください。\n\
      承認者は、所属組織の上長に承認権限を付与しています。\n\
      承認完了後、可視制御登録完了します。\n\
      \n\
      操作方法など詳細は、管理者マニュアルをご参照ください。',
      en: '',
    },
  },
  {
    category: 'qaRegistration',
    icon: 'help_center',
    question: {
      ja: '取引先よりミルシート情報が表示されないと連絡があった',
      en: '',
    },
    answer: {
      ja: '該当ミルシートが検索できるか確認してください。\n\
      検索結果に表示された場合、取引先へ可視制御もしくは詳細可視制御が登録されていない可能性があります。\n\
      可視制御・詳細可視制御の登録状況を確認し、登録がない場合は可視制御の登録・承認依頼を行ってください。\n\
      \n\
      検索結果に表示されない場合、取引先からのミルシート情報が正しいか、鉄鋼M契約情報と相違ないか確認をお願いします。\n\
      ミルシート情報が正しく、Timssに取り込まれていない可能性があると見受けられる場合は、Timss管理者までご連絡ください。',
      en: '',
    },
  },
  // qaSomething
  // ----------------------------------------
  // {
  //   category: '',
  //   icon: 'help_center',
  //   question: {ja: '', en: ''},
  //   answer: {ja: '', en: ''},
  // },
];
